import React from 'react';
import { motion } from 'framer-motion';
export function AuthorityBlock() {
  return <section id="resources" className="bg-cool-gray py-24 overflow-hidden" data-id="element-22">
      <div className="max-w-4xl mx-auto px-6" data-id="element-23">
        <motion.div initial={{
        opacity: 0,
        scale: 0.98
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8,
        ease: 'easeOut'
      }} className="bg-stark-white p-12 md:p-20 shadow-xl border border-gray-200 text-center space-y-8 relative overflow-hidden" data-id="element-24">
          <motion.div initial={{
          height: 0
        }} whileInView={{
          height: '100%'
        }} viewport={{
          once: true
        }} transition={{
          duration: 1,
          delay: 0.5,
          ease: 'circOut'
        }} className="absolute top-0 left-0 w-2 bg-accent-red" data-id="element-25" />
          <h2 className="text-midnight-navy text-3xl md:text-4xl font-manrope font-bold" data-id="element-26">
            Built Around Real Restaurant Operations.
          </h2>
          <p className="text-midnight-navy/70 text-xl leading-relaxed" data-id="element-27">
            ROI was created from years of hands-on restaurant operational
            experience — built specifically around the day-to-day realities
            restaurant owners face. This isn’t generic software built by people
            outside the industry. It’s designed for operators.
          </p>
        </motion.div>
      </div>
    </section>;
}